import {AppBar, Box, IconButton, Stack, styled, Toolbar, useTheme} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {setSidebarCollapse} from "../../../store/slices/ThemeSlice";
import Profile from "../Profile";

const AppNavbar = () => {
    const themeSetting = useSelector(state => state.theme);
    const dispatch = useDispatch();
    const theme = useTheme();

    const AppBarStyled = styled(AppBar)(({ theme }) => ({
        boxShadow: 'none',
        background: theme.palette.background.default,
        justifyContent: 'center',
        backdropFilter: 'blur(4px)',
        [theme.breakpoints.up('lg')]: {
            minHeight: themeSetting.toolbarHeight,
        },
    }));

    const ToolbarStyled = styled(Toolbar)(({ theme }) => ({
        color: theme.palette.text.secondary,
    }));

    return (
        <AppBarStyled position="sticky" color="default">
            <ToolbarStyled>

                <Box flexGrow={1} />
                <Stack spacing={1} direction="row" alignItems="center">
               
                    <Profile />
                </Stack>
            </ToolbarStyled>
        </AppBarStyled>
    );
};

export default AppNavbar;